
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";

@Component({})
export default class MarkerInfoWindowDetails extends Vue {
	@Prop({ type: String, required: true }) 
    private readonly deviceTitle: string;
}
